import React from 'react';

import { DashboardWidgetProps } from './DashboardWidgetProps';

const ScoreBoardWidget: React.FC<DashboardWidgetProps> = (props: DashboardWidgetProps) => {
  return <></>;
};

export default ScoreBoardWidget;
